import { SxProps, Theme } from '@mui/material';

export const editPreviewModalStyles: Record<string, SxProps<Theme>> = {
  sendFormWrapper: {
    width: '100%',
    minWidth: 0,
    mt: 2,
    border: '1px solid #eee',
    borderRadius: 1,
    p: 2,
  },
  sendFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 0, md: 1 },
  },
  sendFormTitle: {
    borderBottom: '1px solid var(--table-header-bg)',
    pb: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  sendFormTabsWrapper: {
    borderBottom: 1,
    borderColor: 'divider',
    marginBottom: 2,
    width: 'fit-content',
  },
  subjectBox: {
    mb: 2,
  },
};
